import React, { useEffect, useRef, useState } from "react";
import api from "../api/api"
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { emailrgx } from "../assets/constant";
import { useAuth } from "../context/AuthContext";
import PropTypes from 'prop-types';
import { useTranslation } from "react-i18next";
import { useHistory, useLocation } from "react-router-dom";
const AddAgency = (prop) => {

     const history = useHistory();
  const location = useLocation();

const { t } = useTranslation();

      const {user} = useAuth();
    const modalRef = useRef(null);
    const schema = yup.object({
      email: yup
        .string()
        .matches(emailrgx, t("Email format is required"))
        .required(t("Email is required"))
        .trim(),
    });
    const {
      reset,
      handleSubmit,
      register,
      setError,
      clearErrors,
      formState: { errors },
    } = useForm({
      resolver: yupResolver(schema),
      //defaultValues: inputValues,
    });


     const [loadingSendInv,setloadingSendInv] = useState(false)
     const [successinvite,setsuccessinvite] = useState(null)
    const { onRefresh } = prop;

     
     const onSubmit = async(data) => {
        clearErrors();
        setsuccessinvite(null)
        let typeurl;
        if (user.type == "supplier")typeurl="/supplier-invite-agency/"
        else return

        if (loadingSendInv) return;
        setloadingSendInv(true);
        
        try {
            const response = await api.post(typeurl, data ); 

           
            console.log("Response Code:", response.status);
            console.log("Form submitted successfully!");

            reset();
            setsuccessinvite(response.data['result'])

           

            document.querySelector('#add_agency .btn-close')?.click();

             // Redirect to vendor-invitations if current path is vendor-list  
      if (location.pathname === '/agency-list') {
     
        history.push('/agencies-invitations');
      }else {
        if (onRefresh) onRefresh();
      }
        } catch (error) {
       
           let  errorMessage = ""
            // Extract response code if available
            const responseCode = error.response ? error.response.status : "Unknown";
            console.log("Response Code:", responseCode);
            if (error?.response?.data) {
                
                 Object.entries(error.response.data).forEach(([key, values]) => {
                   //if (key !== "token" && key !== "invite-agency-vendo") {
                     console.log(key, values);
                     errorMessage += `${values}\n`;
                   //}
                 });
               }
             
               // If no specific error was found, provide a default message
               if (!errorMessage) {
                
                 errorMessage = "An unknown error occurred.";
               }
               
               // Set the error message in React Hook Form
               setError("root", { type: "server", message: errorMessage });
   
        } finally {
            setloadingSendInv(false);
        }
    }
    
    useEffect(()=>{
        clearErrors();
    },[])

    return (
        <div className="modal custom-modal modal-lg fade" id="add_agency" role="dialog" ref={modalRef}>
            <div className="modal-dialog modal-dialog-centered modal-md">
                <div className="modal-content">
                    <div className="modal-header border-0 pb-0">
                        <div className="form-header modal-header-title text-start mb-0">
                            <h4 className="mb-0">{t("Add Agency")}</h4>
                        </div>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <form  onSubmit={handleSubmit(onSubmit)}>
                        <div className="modal-body">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="card-body">
                                        <div className="form-groups-item">
                                            <div className="row">
                                                <div className="col-md-12">
                                                    <div className="input-block mb-3">
                                                        <label>{t("Email")}</label>
                                                        <input type="email"
                                                         {...register("email")}
                                                          className="form-control"  />
                                                        <small className="text-danger">{errors?.email?.message}</small>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer">
                        {/* <small  style={{color:"green"}}> {successinvite && <p>Your invitation was successfully delivered to <b>{successinvite}</b></p>}</small> */}
                        <small  style={{color:"red"}}> {errors.root && <p>{errors.root.message}</p>}</small>
                        <div className="d-flex justify-content-end w-100 mt-2">
                            <button type="button" data-bs-dismiss="modal" className="btn btn-back cancel-btn me-2">{t("Cancel")}</button>
                            <button type="submit"  className="btn btn-primary ">{t("Add Agency")}
                            {loadingSendInv && <i className="fa-solid fa-spinner fa-spin" style={{margin: "0 10px"}}></i> }
                            
                            </button>
                        </div>    
                        </div>
                    </form>
                </div>
            </div>
        </div>
    ); 
};
AddAgency.propTypes = {
    refreshData: PropTypes.func.isRequired,
  };
export default AddAgency;
